export default __webpack_public_path__ + "static/media/sam_w1024.ae82afa3.jpeg";